import { useState, useEffect } from 'react';
import { avatarService } from '../services/avatarService';

interface UseAvatarProps {
  userId?: string;
  avatarBase64?: string;
}

export const useAvatar = ({ userId, avatarBase64 }: UseAvatarProps) => {
  const [avatarUrl, setAvatarUrl] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!userId) {
      setAvatarUrl('');
      return;
    }

    // Usar avatarBase64 como versionId para cache-busting
    const versionId = avatarBase64 || Date.now().toString();
    const avatarFileUrl = avatarService.getAvatarFileUrl(userId, versionId);
    setAvatarUrl(avatarFileUrl);
  }, [userId, avatarBase64]);

  return { avatarUrl, isLoading };
};
